/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

class BundleConfig extends HTMLElement {
  constructor() {
    super();
    this.formItems = this.querySelectorAll("[data-form]");
    this.openDrawerEvent = new CustomEvent("theme:drawer-custom:show", {
      bubbles: true,
    });
    this.customDrawer = document.querySelector("custom-drawer#custom-drawer");
    this.currentVariantId = this.getAttribute("data-variant-id");

    this.configurations = {};
    this.configurations[parseInt(this.currentVariantId)] = [];

    this.bundleBlocks = this.querySelectorAll(".configurator--block");
    this.bundleSize = parseInt(this.getAttribute("data-limit"));

    this.texts = {};
    this.texts.popupSingleText = this.getAttribute(
      "data-selection-single-text"
    );
    this.texts.popupMultipleText = this.getAttribute(
      "data-selection-multiple-text"
    );
    this.texts.popupDoneText = this.getAttribute("data-selection-done-text");
    this.texts.atcNotDoneText = this.getAttribute("data-selection-atc-text");
    this.texts.atcDoneText = this.getAttribute("data-selection-atc-default");

    this.atcButton = document.querySelector(
      `form[id="${this.getAttribute("data-form")}"] button[type="submit"]`
    );
    this.atcButton?.setAttribute("data-prevent", true);
    if (this.atcButton?.querySelector("[data-add-to-cart-text]")) {
      this.atcButton.querySelector("[data-add-to-cart-text]").textContent =
        this.texts.atcNotDoneText.replace("[amount]", this.bundleSize);

      this.pdpForm = this.atcButton.closest("form");
    }

    this.progressContainer = this.querySelector("[data-progress-text]");
    this.progressDoneContainer = this.querySelector("[data-done-text]");
    this.enableLogs = true;

    this.giftDiv = this.querySelector(".configurator--block-gift");
    this.productData = JSON.parse(
      this.getAttribute("data-product-json-bundle") || "{}"
    );

    this.isMultiLevel = this.getAttribute("data-is-multiple") === "true";
  }

  connectedCallback() {
    this.addListeners();
  }

  log(input) {
    if (this.enableLogs) {
      console.log("[BundleConfig]", input);
    }
  }

  /*
  adds Event listeners on Variant Change Events
  */
  addListeners() {
    document.addEventListener(
      "theme:variant:change",
      this.handleVariantChange.bind(this)
    );
    console.log(this.bundleBlocks);
    this.bundleBlocks.forEach((item) => {
      item.addEventListener("click", this.handleItemClick.bind(this));
    });

    /**
     * Add Listeners to ATC Button
     */

    this.atcButton.addEventListener("click", this.handleATCClick.bind(this));
  }

  handleATCClick(e) {
    if (
      !this.configurations[this.currentVariantId].length === this.bundleSize
    ) {
      e.preventDefault();
      this.customDrawer.openCustomDrawer();
      this.log("Not all Blocks chosen, opening Drawer");
    }
  }

  /*
    Handle Click of Item
  */
  handleItemClick(e) {
    console.log("ITEM CLICK");
    if (e.target.closest(`.configurator--block[data-choose="false"]`)) {
      this.customDrawer.openCustomDrawer();
    } else {
      if (e.target.closest("[data-remove]")) {
        this.removeIndex(
          parseInt(e.target.closest("[data-remove]").getAttribute("data-index"))
        );
      }
    }
  }

  /*
  Handle Variant Change of Mother Product to Display and Enable/Disable Form Items.
  */

  handleVariantChange(e) {
    let { variant } = e.detail;
    console.log(variant, e.detail);

    if (!variant) {
      console.error("Variant Theme Event is corrupted");
      return;
    }

    if (variant.option1 && this.isMultiLevel) {
      if (!this.configurations[variant.id]) {
        this.configurations[variant.id] = [];
      }

      this.setAttribute("data-limit", variant.option1);
      this.customDrawer
        .querySelector(".bundle-chosen-items--container")
        .setAttribute("data-limit", variant.option1);
      this.bundleSize = parseInt(this.getAttribute("data-limit"));

      let motherVariant = this.productData?.variants?.find(
        (item) => item.id === parseInt(variant.id)
      );
      if (motherVariant && motherVariant.option1) {
        //Alle Variants im Mutterprodukt, die diselbe Größe Haben
        let filteredSizeVariants = this.productData?.variants?.filter(
          (item) => item.option2 === motherVariant.option2
        );

        //Alle Varianten Ablaufen
        for (const sizeVariant of filteredSizeVariants) {
          if (
            this.configurations[sizeVariant.id] &&
            this.configurations[sizeVariant.id].length
          ) {
            if (this.configurations[variant.id].length === 0) {
              for (let i = 0; i < Number(this.bundleSize); i++) {
                if (this.configurations[sizeVariant.id][i]) {
                  this.configurations[variant.id].push(
                    this.configurations[sizeVariant.id][i]
                  );
                }
              }
            }
          }
        }
      }
    }

    /*
      Hide and remove non-needed Items from Form.
    */

    this.formItems.forEach((item) => {
      if (item.getAttribute("data-variant") === variant.id.toString()) {
        item.setAttribute("form", item.getAttribute("data-form"));
        //item.classList.remove("hidden");
        this.currentVariantId = variant.id;

        if (!this.configurations[variant.id]) {
          this.configurations[variant.id] = [];
        }

        this.customDrawer
          .querySelectorAll("bundle-handler")
          .forEach((handler) => {
            if (parseInt(handler.getAttribute("data-id")) !== variant.id) {
              handler.setAttribute("hidden", true);
            } else {
              handler.removeAttribute("hidden");
            }
          });
        this.setForm();
      } else {
        item.removeAttribute("form");
        item.classList.add("hidden");
      }
    });
  }

  /* Add Product to configuration*/

  addProduct(variant) {
    if (!this.configurations[variant.bundleID]) {
      this.log("Re-Initing Configuration for this Mother ID");
      this.configurations[variant.bundleID] = [];
    }

    if (this.configurations[variant.bundleID].length === this.bundleSize) {
      return;
    }
    this.configurations[variant.bundleID].push({
      variantTitle: variant.name,
      qty: 1,
      id: variant.id,
      imgUrl: variant.imgUrl,
      handle: variant.handle,
    });
    this.setForm();
  }

  removeIndex(index) {
    this.log(`Removing ${index}th item`);
    this.configurations[this.currentVariantId].splice(index, 1);
    this.setForm();
  }

  setForm() {
    /*
      Set Data in Blocks
    */

    let activeFormItems = this.querySelectorAll(
      `[data-form][data-variant="${this.currentVariantId}"]`
    );

    this.configurations[this.currentVariantId].forEach((item, index) => {
      activeFormItems[index].value = `gid://shopify/ProductVariant/${item.id}`;
      this.bundleBlocks[index].setAttribute("data-choose", true);
      let imgContainer = this.bundleBlocks[index].querySelector(
        ".configurator-image--container"
      );
      imgContainer.innerHTML = "";
      let image = document.createElement("img");
      image.src = item.imgUrl;
      imgContainer.appendChild(image);

      let titleContainer = this.bundleBlocks[index].querySelector(
        "[data-config-title]"
      );
      titleContainer.textContent = item.variantTitle;
    });
    /*
      Reset Removed / Emtpy State
    */

    for (
      let i = this.configurations[this.currentVariantId].length;
      i < this.bundleBlocks.length;
      i++
    ) {
      activeFormItems[i].value = ``;
      this.bundleBlocks[i].setAttribute("data-choose", false);

      let imgContainer = this.bundleBlocks[i].querySelector(
        ".configurator-image--container"
      );
      imgContainer.innerHTML = ""; // Remove leftover image

      let titleContainer = this.bundleBlocks[i].querySelector(
        "[data-config-title]"
      );
      titleContainer.textContent = ""; // Clear title
    }

    /**
     * Create Form Items to be used later by the cart
     */

    if (this.pdpForm) {
      this.pdpForm.querySelectorAll("[data-bundle-handles]").forEach((item) => {
        item.remove();
      });

      let handleString = "";
      this.configurations[this.currentVariantId].forEach((item) => {
        if (handleString) {
          handleString += ",";
        }
        handleString += item.handle;
      });

      if (document.querySelector(".configurator--block-gift")) {
        handleString += `,${document
          .querySelector(".configurator--block-gift")
          .getAttribute("data-handle")}`;
      }

      let tempInput = document.createElement("input");
      tempInput.type = "hidden";
      tempInput.value = handleString;
      tempInput.name = "properties[_bundle_handles]";
      tempInput.setAttribute("data-bundle-handles", true);
      this.pdpForm.appendChild(tempInput);
    }

    this.handleTextsAndUI();
    this.customDrawer.setImages(
      this.configurations[this.currentVariantId],
      this.bundleSize
    );
  }

  handleTextsAndUI() {
    /**
     * Close Drawer
     */
    let remainingProducts =
      this.bundleSize - this.configurations[this.currentVariantId].length;
    if (this.configurations[this.currentVariantId].length === this.bundleSize) {
      this.customDrawer.closeCustomDrawer();
    }

    /**
     * Handle ATC Button
     */

    if (this.configurations[this.currentVariantId].length === this.bundleSize) {
      this.atcButton.querySelector("[data-add-to-cart-text]").textContent =
        this.texts.atcDoneText;
      this.atcButton?.removeAttribute("data-prevent");
      this.giftDiv?.classList.add("is-selected");
    } else {
      this.atcButton.querySelector("[data-add-to-cart-text]").textContent =
        this.texts.atcNotDoneText;
      this.atcButton?.setAttribute("data-prevent", true);
      this.giftDiv?.classList.remove("is-selected");
    }

    /**
     * Handle Display-Text Boxes
     */

    if (this.configurations[this.currentVariantId].length === this.bundleSize) {
      this.progressContainer.classList.add("hidden");
      this.progressDoneContainer.classList.remove("hidden");
    } else {
      this.progressContainer.textContent =
        remainingProducts === 1
          ? this.texts.popupSingleText
          : this.texts.popupMultipleText.replace("[amount]", remainingProducts);
      this.progressContainer.classList.remove("hidden");
      this.progressDoneContainer.classList.add("hidden");

      if (remainingProducts === this.bundleSize) {
        this.progressContainer.classList.add("hidden");
      }
    }
  }
}

window.customElements.define("bundle-config", BundleConfig);

class BundleHandler extends HTMLElement {
  constructor() {
    super();

    this.bundleConfig = document.querySelector(
      `bundle-config[data-pid="${this.getAttribute("data-pid")}"]`
    );
    //this.log(this.bundleConfig);
    this.variantCards = this.querySelectorAll(".bundle-item--block");
    this.bundleConfig = document.querySelector("bundle-config");
    this.enableLogs = true;
  }

  log(input) {
    if (this.enableLogs) {
      console.log("[BundleHandler]", input);
    }
  }

  handleCardClick(e) {
    let variantCard = e.target.closest("[data-variant]");
    let variantData = JSON.parse(variantCard.getAttribute("data-variant"));
    variantData.bundleID = parseInt(this.getAttribute("data-id"));
    variantData.imgUrl = variantCard.getAttribute("data-image-url");
    variantData.handle = variantCard.getAttribute("data-handle");
    this.bundleConfig.addProduct(variantData);
  }

  connectedCallback() {
    this.variantCards.forEach((item) => {
      item.addEventListener("click", this.handleCardClick.bind(this));
    });
  }

  disconnectedCallback() {
    this.variantCards.forEach((item) => {
      item.removeEventListener("click", this.handleCardClick.bind(this));
    });
  }
}

if (!customElements.get("bundle-handler")) {
  customElements.define("bundle-handler", BundleHandler);
}

const classes$m = {
  open: "is-open",
  closing: "is-closing",
  duplicate: "drawer--duplicate",
  drawerEditorError: "drawer-editor-error",
};

const selectors$r = {
  customDrawer: "cart-drawer",
  customDrawerClose: "[data-cart-drawer-close]",
  customDrawerSection: '[data-section-type="cart-drawer"]',
  customDrawerInner: "[data-cart-drawer-inner]",
  shopifySection: ".shopify-section",
};

const attributes$g = {
  drawerUnderlay: "data-drawer-underlay",
};

class CustomDrawer extends HTMLElement {
  constructor() {
    super();

    this.customDrawerIsOpen = false;

    this.customDrawerClose = this.querySelector(selectors$r.customDrawerClose);
    this.customDrawerInner = this.querySelector(selectors$r.customDrawerInner);
    this.openCustomDrawer = this.openCustomDrawer.bind(this);
    this.closeCustomDrawer = this.closeCustomDrawer.bind(this);
    this.toggleCustomDrawer = this.toggleCustomDrawer.bind(this);
    this.customDrawerSection = this.closest(selectors$r.shopifySection);
    this.a11y = window.theme.a11y;

    this.bundleBlocks = this.querySelectorAll(".configurator--block");

    this.bundleItems = this.querySelectorAll(
      "bundle-handler .bundle-item--block"
    );

    if (this.bundleBlocks.length) {
      this.bundleBlocks.forEach((item) => {
        if (item.querySelector("[data-remove]")) {
          item
            .querySelector("[data-remove]")
            .addEventListener("click", this.handleCloseBlock.bind(this));
        }
      });
    }

    this.statusText = this.querySelector("[data-status-text]");

    this.texts = {
      incomplete: this.statusText?.getAttribute("data-text-incomplete") || "",
      "x-incomplete":
        this.statusText?.getAttribute("data-text-x-remaining") || "",
      complete: this.statusText?.getAttribute("data-text-complete") || "",
    };

    this.closeCartEvents();
    this.enableLogs = true;
  }

  connectedCallback() {
    const drawerSection = this.closest(selectors$r.shopifySection);

    // /* Prevent duplicated cart drawers */
    // if (window.theme.hasCustomDrawer) {
    //   if (!window.Shopify.designMode) {
    //     drawerSection.remove();
    //     return;
    //   } else {
    //     const errorMessage = document.createElement("div");
    //     errorMessage.classList.add(classes$m.drawerEditorError);
    //     errorMessage.innerText = "Cart drawer section already exists.";

    //     if (!this.querySelector(`.${classes$m.drawerEditorError}`)) {
    //       this.querySelector(selectors$r.customDrawerInner).append(
    //         errorMessage
    //       );
    //     }

    //     this.classList.add(classes$m.duplicate);
    //   }
    // }

    window.theme.hasCustomDrawer = true;

    document.addEventListener("theme:drawer-custom:show", () => {
      if (this.id === "custom-drawer") {
        this.openCustomDrawer(true);
      }
    });
    document.addEventListener(
      "theme:drawer-custom:toggle",
      this.toggleCustomDrawer
    );
    document.addEventListener("theme:quick-add:open", this.closeCustomDrawer);

    this.querySelectorAll("[data-cart-drawer-close]").forEach((button) => {
      button.addEventListener("click", this.closeCustomDrawer());
    });
  }

  disconnectedCallback() {
    document.removeEventListener(
      "theme:product:added",
      this.openCustomDrawerOnProductAdded
    );
    document.removeEventListener("theme:cart:toggle", this.toggleCustomDrawer);
    document.removeEventListener(
      "theme:quick-add:open",
      this.closeCustomDrawer
    );

    if (document.querySelectorAll(selectors$r.customDrawer).length <= 1) {
      window.theme.hasCustomDrawer = false;
    }

    appendCartItems();
  }

  log(input) {
    if (this.enableLogs) {
      console.log("[CustomDrawer]", input);
    }
  }

  /**
   * Open cart drawer and add class on body
   *
   * @return  {Void}
   */

  openCustomDrawer(forceOpen = false) {
    if (!forceOpen && this.classList.contains(classes$m.duplicate)) return;

    this.customDrawerIsOpen = true;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener("click", this.onBodyClickEvent);

    document.dispatchEvent(
      new CustomEvent("theme:cart-drawer:open", {
        detail: {
          target: this,
        },
        bubbles: true,
      })
    );
    document.dispatchEvent(
      new CustomEvent("theme:scroll:lock", { bubbles: true })
    );

    this.classList.add(classes$m.open);

    window.theme.waitForAnimationEnd(this.customDrawerInner).then(() => {
      this.a11y.trapFocus(this, {
        elementToFocus: this.querySelector(selectors$r.customDrawerClose),
      });
    });
  }

  /**
   * Close cart drawer and remove class on body
   *
   * @return  {Void}
   */

  closeCustomDrawer() {
    if (!this.classList.contains(classes$m.open)) return;

    this.classList.add(classes$m.closing);
    this.classList.remove(classes$m.open);

    this.customDrawerIsOpen = false;

    document.dispatchEvent(
      new CustomEvent("theme:cart-drawer:close", {
        bubbles: true,
      })
    );

    this.a11y.removeTrapFocus();
    this.a11y.autoFocusLastElement();

    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.dispatchEvent(
      new CustomEvent("theme:scroll:unlock", { bubbles: true })
    );

    window.theme.waitForAnimationEnd(this.customDrawerInner).then(() => {
      this.classList.remove(classes$m.closing);
    });
  }

  /**
   * Toggle cart drawer
   *
   * @return  {Void}
   */

  toggleCustomDrawer() {
    if (!this.customDrawerIsOpen) {
      this.openCustomDrawer();
    } else {
      this.closeCustomDrawer();
    }
  }

  /**
   * Event click to element to close cart drawer
   *
   * @return  {Void}
   */

  closeCartEvents() {
    this.customDrawerClose.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeCustomDrawer();
    });

    this.addEventListener("keyup", (e) => {
      if (e.code === "Escape") {
        this.closeCustomDrawer();
      }
    });
  }

  onBodyClick(e) {
    if (e.target.hasAttribute(attributes$g.drawerUnderlay))
      this.closeCustomDrawer();
  }

  /*
      Set Footer Images
  */

  setImages(configuration, maxSize) {
    console.log("Setting up Images");
    /**
     * Check if item was chosen, if yes add border and plus sign via css
     */

    this.bundleItems.forEach((bundleItem) => {
      bundleItem.classList.remove("is-selected");
    });

    if (configuration.length > 0) {
      this.statusText.textContent = this.texts["x-incomplete"].replace(
        "[amount]",
        maxSize - configuration.length
      );
    }

    if (configuration.length === maxSize) {
      this.statusText.textContent = this.texts["complete"];
    }

    if (!configuration.length) {
      this.statusText.textContent = this.texts["incomplete"];
    }

    this.bundleBlocks.forEach((item, index) => {
      item.querySelector(".configurator-image--container").innerHTML = "";
      this.bundleBlocks[index].removeAttribute("data-id");
    });

    configuration.forEach((item, index) => {
      let imgObj = document.createElement("img");
      imgObj.src = item.imgUrl;
      this.bundleBlocks[index]
        .querySelector(".configurator-image--container")
        .appendChild(imgObj);
      this.bundleBlocks[index].setAttribute("data-id", item.id);

      this.querySelector(
        `[upsell-drawer-item][data-variant-id="${item.id}"]`
      )?.classList.add("is-selected");

      /*
      Added A querySelectorAll for all Image Boxes
      */
      let drawerImages = this.querySelectorAll(
        `[upsell-drawer-item][data-variant-id="${item.id}"]`
      );

      if (drawerImages.length) {
        drawerImages.forEach((item) => {
          item.classList.add("is-selected");
        });
      }
    });
  }

  /**
   * Handle Removing the Close Butotn on the Generated blocks
   */

  handleCloseBlock(e) {
    let index = parseInt(
      e.target.closest("[data-remove]").getAttribute("data-index")
    );
    document.querySelector("bundle-config").removeIndex(index);
  }
}

if (!customElements.get("custom-drawer")) {
  customElements.define("custom-drawer", CustomDrawer);
}

class GiftConfig extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.querySelector("#custom-drawer-gifts");
    this.drawerHandlers = this.drawer.querySelectorAll("gift-handler");
    this.freeGifts = this.querySelectorAll("gift-item");
    this.freeGifts.forEach((item) => {
      item.addEventListener("click", this.handleGiftClick.bind(this));
    });

    this.dynamicDiv = this.querySelector("[data-dynamic]");

    document.addEventListener(
      "theme:variant:change",
      this.handleVariantChange.bind(this)
    );
    this.querySelector("[data-dynamic]")
      ? this.style.setProperty(
          "--gift-height",
          this.querySelector("[data-dynamic]").scrollHeight
        )
      : null;
  }

  closeDrawer() {
    this.drawer.closeCustomDrawer();
  }

  log(input) {
    console.log("[Gift Config]", input);
  }

  handleGiftClick(e) {
    let giftCard = e.target.closest("gift-item");
    if (!giftCard) {
      return;
    }

    if (giftCard.hasAttribute("data-fixed")) {
      this.showFixedHandler();
    } else {
      this.showDynamicHandler(giftCard);
    }
    this.drawer?.openCustomDrawer();
  }

  showFixedHandler() {
    this.drawerHandlers.forEach((handler) => {
      if (handler.hasAttribute("data-fixed")) {
        handler.classList.remove("hidden");
      } else {
        handler.classList.add("hidden");
      }
    });
  }

  showDynamicHandler(target) {
    this.drawerHandlers.forEach((handler) => {
      if (
        handler.getAttribute("data-vid") === target.getAttribute("data-vid")
      ) {
        handler.classList.remove("hidden");
      } else {
        handler.classList.add("hidden");
      }
    });
  }

  handleVariantChange(e) {
    let { id } = e.detail?.variant;
    let foundHandler = this.drawer.querySelector(`[data-vid="${id}"]`);

    if (foundHandler) {
      this.dynamicDiv.classList.remove("hidden-custom");
      this.dynamicDiv.setAttribute("data-vid", id);
      let firstVariantDiv = foundHandler.querySelector("[gift-drawer-item]");
      this.dynamicDiv
        .querySelector("[data-image]")
        .setAttribute("src", firstVariantDiv.getAttribute("data-image-url"));
      this.dynamicDiv.querySelector("[data-image]").removeAttribute("srcset");
      this.dynamicDiv
        .querySelector("input")
        .setAttribute(
          "value",
          `gid://shopify/ProductVariant/${foundHandler
            .querySelector("[data-variant-id]")
            .getAttribute("data-variant-id")}`
        );
    } else {
      this.dynamicDiv.classList.add("hidden-custom");
    }
  }
}

if (!customElements.get("gift-config")) {
  customElements.define("gift-config", GiftConfig);
}

class GiftHandler extends HTMLElement {
  constructor() {
    super();
    this.giftConfig = document.querySelector("gift-config");
    this.giftItems = this.querySelectorAll("[gift-drawer-item]");
    this.giftItems.forEach((item) => {
      item.addEventListener("click", this.handleItemClick.bind(this));
    });
  }

  handleItemClick(e) {
    let giftItem = e.target.closest("[gift-drawer-item]");
    let variantData = JSON.parse(giftItem.getAttribute("data-variant"));
    let { id } = variantData;
    let imageUrl = giftItem.getAttribute("data-image-url");

    let target;
    if (this.hasAttribute("data-fixed")) {
      target = this.giftConfig.querySelector("[data-fixed]");
    } else {
      target = this.giftConfig.querySelector("[data-dynamic]");
    }

    target.querySelector("[data-image]").setAttribute("src", imageUrl);
    target.querySelector("[data-image]").removeAttribute("srcset");
    target
      .querySelector("input")
      .setAttribute("value", `gid://shopify/ProductVariant/${id}`);

    this.giftConfig.closeDrawer();
  }
}

if (!customElements.get("gift-handler")) {
  customElements.define("gift-handler", GiftHandler);
}

class CustomFilterLabel extends HTMLLabelElement {
  constructor() {
    super();
    this._boundDown = this.handleDown.bind(this);
  }

  connectedCallback() {
    this.addEventListener("mousedown", this._boundDown);
  }

  disconnectedCallback() {
    this.removeEventListener("mousedown", this._boundDown);
  }

  handleDown(e) {
    this.closest("li").classList.toggle("custom__filter--active");
  }
}

if (!customElements.get("custom-filter-label")) {
  customElements.define("custom-filter-label", CustomFilterLabel, {
    extends: "label",
  });
}

class VariantSiblings extends HTMLElement {
  constructor() {
    super();
    this.childrenContainer = this.querySelectorAll("[data-vid]");
    this._onVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    document.addEventListener("theme:variant:change", this._onVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener("theme:variant:change", this._onVariantChange);
  }

  handleVariantChange(e) {
    this.childrenContainer.forEach((container) => {
      if (container.getAttribute("data-vid") && e.detail?.variant?.id) {
        let containerId = Number(container.getAttribute("data-vid"));
        if (containerId === e.detail?.variant?.id) {
          container.removeAttribute("hidden");
        } else {
          container.setAttribute("hidden", true);
        }
      }
    });
  }
}

if (!customElements.get("variant-siblings")) {
  customElements.define("variant-siblings", VariantSiblings);
}

document.addEventListener("DOMContentLoaded", () => {
  if (window.scrollY === 0) {
    document.body.classList.add("at-top");
  }

  document.addEventListener("scroll", () => {
    if (window.scrollY === 0) {
      document.body.classList.add("at-top");
    } else {
      document.body.classList.remove("at-top");
    }
  });
});
